<template>
  <div class="attachment-ul">
    <template v-if="fileInfo && fileInfo.length > 0">
      <div
        v-for="(attachment, attachmentIndex) in fileInfo"
        class="attachment-li attachment-det-li"
        :key="attachmentIndex"
        :style="{backgroundColor:color?color:''}"
      >
        <i class="utm-font utm-generate-logo-icon"></i>
        <div @click="viewAttachment(attachment)">
          <utmEllipsis :content="attachment.fileName||attachment.name" transfer></utmEllipsis>
        </div>
        <span class="attachment_size" v-if="attachment.fileSize || attachment.size"
          >({{ returnAttachmentSize(attachment) }})</span
        >
        <psim-icon
          v-if="edit"
          type="utm-font utm-delete-icon"
          left="8"
          color="#8C8C8C"
          size="16"
          @onClick="deleteAttachment(attachment, attachmentIndex)"
        ></psim-icon>
        <span v-else @click="downloadFile(attachment)">
          <i class="utm-font utm-download-icon"></i>
        </span>
      </div>
    </template>
    <span v-else>-</span>
    <!-- 播放视频弹窗 -->
    <teleport to="body">
      <utm-modal
        :utmModal="videoModal"
        width="1376px"
        top="60px"
        @closeModal="videoModal = false"
        style="z-index: 1002"
      >
        <template slot="header">
          <span>{{ "Video" }} </span>
        </template>
        <template slot="main">
          <playVideo
            ref="messageVideo"
            :tabMode="-1"
            :videoMode="-1"
            :style="{ height: $root.contentHeight - 200 + 'px' }"
          ></playVideo>
        </template>
        <template slot="footer">
          <button
            type="button"
            class="utm-btn utm-linear-btn"
            @click="videoModal = false"
          >
            Close
          </button>
        </template>
      </utm-modal>
    </teleport>
  </div>
</template>

<script>
import playVideo from '../utmPlayVideo.vue'
import utmEllipsis from '../utmEllipsis.vue'
import teleport from "../utmTeleport.vue";
export default {
  name: 'UtmFilesPanel',
  components: {
    utmEllipsis,
    playVideo,
    teleport
  },
  props: {
    fileInfo: { // 附件信息
      type: Array,
      required: true
    },
    // 编辑或者查看
    edit: {
      type: Boolean,
      default: false
    },
    color:{
      type:String,
      default:''
    }
  },
  data () {
    return {
      videoModal: false,
    };
  },

  methods: {
    // 预览附件
    viewAttachment (item) {
      let _this = this;
      let url = null;
      let type = item.type
      
      if(!type){
        let name = item.fileName || item.name;
        const extension = name.split('.').pop().toLowerCase();
        if (extension === 'mp3') {
           type = 2
        } else if (extension === 'mp4') {
          type = 1
        } else if (extension === 'png' || extension === 'gif' || extension === 'jpeg' || extension === 'jpg') {
          type = 0
        }
      }
      if (item.fileId) {
        url = _this.$root.fileBaseUrl + 'Files/Get/' + item.fileId + '?access_token=' + _this.ApiService.accessToken.substr(7);
      } else if (item.fileData) {
        url = item.imgBase64Type + item.fileData;
      }
      if (type === 1) {
        _this.videoModal = true;
        _this.$nextTick(() => {
          _this.$refs.messageVideo.palyVideoUrl(url);
        })
      } else if (type === 2) {
        if (_this.audioWrapper) {
          _this.audioWrapper.pause();
          _this.audioWrapper.load();
          _this.audioWrapper.src = url;
          _this.audioSchedule = 0;
          _this.audioWrapper.play();
          _this.audioFlag = true;
          _this.audioWrapper.addEventListener('ended', function () {
            _this.audioFlag = false;
          }, false);
          _this.audioWrapper.addEventListener("timeupdate", function () {//监听音频播放的实时时间事件
            //用秒数来显示当前播放进度
            _this.audioSchedule = (_this.audioWrapper.currentTime / _this.audioWrapper.duration).toFixed(2);
          }, false);
        } else {
          _this.audioWrapper = new Audio(url);
          _this.audioSchedule = 0;
          _this.audioWrapper.play();
          _this.audioFlag = true;
          _this.audioWrapper.addEventListener('ended', function () {
            _this.audioFlag = false;
          }, false);
          _this.audioWrapper.addEventListener("timeupdate", function () {//监听音频播放的实时时间事件
            //用秒数来显示当前播放进度
            _this.audioSchedule = (_this.audioWrapper.currentTime / _this.audioWrapper.duration).toFixed(2);
          }, false);
        }
      } else if (type === 0) {
        _this.$root.viewBigImg(url);
      }
    },
    // 计算附件大小
    returnAttachmentSize (attachment) {
      let number = attachment.fileSize || attachment.size
      let size = number / 1048576
      if (size >= 0.1) {
        return size.toFixed(1) + 'M'
      } else {
        return (size * 1024).toFixed(1) + "K"
      }
    },
    // 删除附件
    deleteAttachment (fileInfo, attachmentIndex) {
      this.$emit('deleteAttachment', fileInfo, attachmentIndex)
    },
    /** 附件下载 */
    downloadFile (file) {
      this.shareApi.getFileContent(file);
    },
  },
};
</script>
<style scoped>
/* 上传附件样式 Start */
.attachment-ul {
  display: flex;
  flex-direction: column;
}
.attachment-li {
  width: max-content;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin-top: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 32px;
  background: rgba(164, 164, 164, 0.1);
  border-radius: 8px;
  padding: 8px 16px 8px 8px;
}
.attachment-det-li {
  background: #ffffff;
}
.attachment-det-li:hover {
  background: rgba(5, 159, 232, 0.1) !important;
  color: var(--main-color);
}
.attachment-li .utm-font {
  color: #8c8c8c;
  font-size: 16px;
  margin-right: 5px;
}
.attachment-li .utm-download-icon {
  margin-left: 8px;
  display: none;
}
.attachment-det-li:hover .utm-font{
  color: var(--main-color);
  display: block;
}
.attachment_size {
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  color: #8c8c8c;
  display: inline-block;
  margin: 0 7px 0 3px;
}
.attachment-li > span:first-of-type {
  display: inline-block;
  max-width: calc(100% - 100px);
}
/deep/ .attachment-li > span .utm-ellipsis-txt {
  color: var(--main-color);
}

/deep/ .attachment-li .utm-ellipsis-txt{
  font-size: 16px;
}
.attachment-li .psim-font {
  width: 18px;
  height: 18px;
}
/deep/ .attachment-li > span:first-of-type:hover .utm-ellipsis-txt {
  text-decoration: underline !important;
}

.attachment-ul > .attachment-ul:first-of-type {
  margin-top: 0px !important;
}
.attachment-upload {
  display: inline-block;
}
.attachment-desc {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #b4b4b4;
  display: inline-block;
  margin-left: 3px;
}
.attachment-btn {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #005eb8;
  cursor: pointer;
  display: inline-block;
  margin-left: 4px;
}
/* 上传附件样式 End */
</style>



// WEBPACK FOOTER //
// src/admin/components/commonComponents/utm-files-panel/utm-files-panel.vue